export default __webpack_public_path__ + "static/media/location.fba65a59.svg";